import styles from './FilterRail.module.css'
import { clearAllFilters, removeParamRef, type CategoryFilterState } from 'lib/dealhunt/filters'
import type { AppliedFilterToken } from 'lib/dealhunt/types'

interface ActiveTokensProps {
  tokens: AppliedFilterToken[]
  filters: CategoryFilterState
  onChange: (next: CategoryFilterState) => void
}

/** Removable tokens for every applied filter (one per option or range), + Clear all. */
const ActiveTokens: React.VFC<ActiveTokensProps> = ({ tokens, filters, onChange }) => {
  if (tokens.length === 0) {
    return null
  }
  return (
    <div className={styles.tokens}>
      {tokens.map(t => (
        <span key={`${t.param.key}:${t.param.value ?? ''}`} className={styles.token}>
          <span className={styles.tokenLabel}>
            <span className={styles.tokenGroup}>{t.label}</span>
            {t.valueLabel}
          </span>
          <button
            type="button"
            className={styles.tokenX}
            aria-label={`Remove ${t.label}: ${t.valueLabel}`}
            onClick={() => onChange(removeParamRef(filters, t.param))}
          >
            {'×'}
          </button>
        </span>
      ))}
      <button
        type="button"
        className={styles.clearAll}
        onClick={() => onChange(clearAllFilters(filters))}
      >
        {'Clear all'}
      </button>
    </div>
  )
}

export default ActiveTokens
